var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHasi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-df3ff6ad-afb2-4abf-a9f5-b3358baed870",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-21a48df0-9f18-48d7-9c3a-43b4cdb358f9{fill:url(#uuid-95d84eee-701d-4c41-9163-e73065d6c8aa);}.uuid-9a37cdf3-de95-4f30-984a-d60120769b1a{fill:url(#uuid-f79db030-9feb-403d-917a-8c4261b6a498);}.uuid-b2b9eda7-9791-4b41-938d-6c37297691b8{fill:url(#uuid-cbe92245-e914-481d-989d-3e2ac3428119);}.uuid-1c23b78c-4291-4b47-87df-763669f1cffc{fill:#f2f2f2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-cbe92245-e914-481d-989d-3e2ac3428119",
    x1: 214.78,
    y1: -6318.48,
    x2: 214.78,
    y2: -6479.06,
    gradientTransform: "translate(0 -6085.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#846db0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#8a77b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afacd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f79db030-9feb-403d-917a-8c4261b6a498",
    x1: 251.42,
    y1: -6233.28,
    x2: 251.42,
    y2: -6479.06,
    gradientTransform: "translate(0 -6085.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#138ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#33a4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#73c5d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-95d84eee-701d-4c41-9163-e73065d6c8aa",
    x1: 292.64,
    y1: -6176.58,
    x2: 292.64,
    y2: -6479.06,
    gradientTransform: "translate(0 -6085.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#069bae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#54adac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ccbd0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1c23b78c-4291-4b47-87df-763669f1cffc",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-b2b9eda7-9791-4b41-938d-6c37297691b8",
    d: "m228.52,393.41h-27.48l8.89-156.01c0-2.68,2.18-4.85,4.86-4.85,2.68,0,4.85,2.17,4.85,4.85l8.89,156.01Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-9a37cdf3-de95-4f30-984a-d60120769b1a",
    d: "m265.16,393.41h-27.48l8.98-241.02c0-2.63,2.13-4.76,4.76-4.76s4.76,2.13,4.76,4.76l8.98,241.02Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-21a48df0-9f18-48d7-9c3a-43b4cdb358f9",
    d: "m310.96,393.41h-36.64l13.56-297.72c0-2.63,2.13-4.76,4.76-4.76s4.76,2.13,4.76,4.76l13.56,297.72Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHasi);
export default __webpack_public_path__ + "static/media/icon_hasi.23b44674bfb406edbb835947b05e7a2d.svg";
export { ForwardRef as ReactComponent };